import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { TimePipe } from 'src/app/shared/pipes/dateago.pipe';

import { Store } from '@ngrx/store';
import { setNotificationAsRead } from 'src/app/shared/store/_features/notifications/notifications.actions';
import {
  NotificationElement,
  NotificationStatusEnum,
  OwnerNotificationTypeEnum,
} from 'src/app/models/dashboard.shared';

@Component({
  selector: 'app-owner-notification-element',
  templateUrl: './owner-notification-element.component.html',
  styleUrls: ['./owner-notification-element.component.css'],
})
export class OwnerNotificationElementComponent implements OnInit {
  notificationStatusEnum = NotificationStatusEnum;
  @Input() forToast: boolean = false;
  @Input() firstElement: boolean = false;
  @Input() notificationObject: NotificationElement;

  @Output() NotificationElementClicked =
    new EventEmitter<NotificationElement>();
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store
  ) {}

  onClickNotification() {
    this.markNotificationAsRead();
    this.NotificationElementClicked.emit(this.notificationObject);
    switch (this.notificationObject.type) {
      case OwnerNotificationTypeEnum.invitation_accepted:
        this.goToAffiliateProfileById(
          this.notificationObject.target.affiliateId
        );
        break;
      case OwnerNotificationTypeEnum.invitation_rejected:
        this.goToAffiliateProfileById(
          this.notificationObject.target.affiliateId
        );
        break;
      case OwnerNotificationTypeEnum.new_sale:
        this.goToSalesItem(this.notificationObject.target.saleId);
        break;
      case OwnerNotificationTypeEnum.refund:
        this.goToRefundItem(this.notificationObject.target.refundId);
        break;
      case OwnerNotificationTypeEnum.new_comment:
      case OwnerNotificationTypeEnum.comment_reply:
        this.goToManageCourseComment(
          this.notificationObject.target.productId,
          this.notificationObject.target.commentId,
          this.notificationObject.target.itemId,
          this.notificationObject.target.itemType
        );
        break;
      default:
        break;
    }
  }

  goToSalesItem(id: number) {
    this.router.navigate(['dashboard', 'earnings', 'sales', 'item', id]);
  }

  goToRefundItem(id: number) {
    this.router.navigate(['dashboard', 'refund', 'item', id]);
  }

  async markNotificationAsRead() {
    this.store.dispatch(
      setNotificationAsRead({ notificationsIds: [this.notificationObject.id] })
    );
  }

  getNotificationTimeAgo(value: number) {
    const timePipe = new TimePipe();
    let timeAgo: string = timePipe.transform(value * 1000);
    return timeAgo;
  }

  goToAffiliateProfileById(id: number) {
    this.router.navigate(['dashboard', 'affiliate', 'my-affiliates', id]);
  }

  goToManageCourseComment(
    productId: number,
    commentId: number,
    itemId?: string,
    itemType?: string
  ) {
    if (!productId) return;
    // Route: /dashboard/product/:id/course/comments
    const queryParams: any = {};
    if (itemId) queryParams.lessonId = itemId;
    if (itemType) queryParams.itemType = itemType;
    if (commentId) queryParams.commentId = commentId;

    this.router.navigate(
      ['dashboard', 'product', productId, 'course', 'comments'],
      { queryParams }
    );
  }

  ngOnInit() {}
}
